const secrets = {
    third_party_token_set: {
        token_not_found: 'トークンレコードが見つかりません。',
        access_token_expired: 'アクセストークンの有効期限が切れています。アカウントを再接続してください。',
    },
};
export default Object.freeze(secrets);
